import React from 'react';
import { Skeleton } from '@mui/material';

export const OverviewStatsSkeleton = () => (
    <div className="group relative bg-white/80 backdrop-blur-sm overflow-hidden shadow-lg rounded-xl border border-gray-200/50 p-3 sm:p-4">
        <div className="flex items-center space-x-2 sm:space-x-3">
            <Skeleton variant="rounded" width={40} height={40} className="flex-shrink-0" />
            <div className="flex-1">
                <Skeleton variant="text" width="60%" height={20} />
                <Skeleton variant="text" width="40%" height={32} />
            </div>
        </div>
    </div>
);

export const OverviewChartSkeleton = () => (
    <div className="bg-white rounded-xl shadow-lg p-4 sm:p-5 border border-gray-200">
        <div className="flex justify-between items-center mb-3">
            <Skeleton variant="text" width={200} height={32} />
            <Skeleton variant="rounded" width={80} height={24} />
        </div>
        <div className="w-full flex items-center justify-center py-8">
            <Skeleton variant="circular" width={200} height={200} />
        </div>
        <div className="mt-4 pt-3 border-t border-gray-200">
            <div className="grid grid-cols-2 gap-3">
                {[1, 2, 3, 4].map((i) => (
                    <Skeleton key={i} variant="rounded" height={32} />
                ))}
            </div>
        </div>
    </div>
);

export const OverviewLineChartSkeleton = () => (
    <div className="bg-white rounded-xl shadow-lg p-4 sm:p-5 border border-gray-200">
        <Skeleton variant="text" width={150} height={32} className="mb-4" />
        <Skeleton variant="rectangular" width="100%" height={250} className="rounded-lg" />
    </div>
);

export const OverviewBarChartSkeleton = () => (
    <div className="bg-white rounded-xl shadow-lg p-4 sm:p-5 border border-gray-200 mt-4 sm:mt-5">
        <Skeleton variant="text" width={200} height={32} className="mb-4" />
        <div className="space-y-4">
            {[1, 2, 3, 4, 5].map((i) => (
                <div key={i} className="flex items-center gap-4">
                    <Skeleton variant="text" width={30} height={24} />
                    <div className="flex-1">
                        <div className="flex justify-between mb-1">
                            <Skeleton variant="text" width="40%" height={20} />
                            <Skeleton variant="text" width="10%" height={20} />
                        </div>
                        <Skeleton variant="rounded" width="100%" height={12} />
                    </div>
                </div>
            ))}
        </div>
    </div>
);
